export default __webpack_public_path__ + "static/media/Pooj.f1d439a9.jpeg";